// extracted by mini-css-extract-plugin
export default {"cross":"mvJSl9Vgzk9Ffvq_gAn2"};